/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t } from '../../translation-files/translator'
import footer from "../../components/footer";
import createAlert from "./modals/create"
import saveJourney from "./modals/saveJourney"


function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  async oninit({ state, attrs }) {
    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);
    m.redraw();
  },
  // disable due to failures on some browsers
  oncreate() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const accType = urlParams.get('u');
    //   if (accType === 'new')
    //     introJs().start();
  },
  view({ state, attrs }) {
    // console.log({ t: t() })
    return [
      // <!--begin::Header-->
      m(createAlert),
      m(saveJourney),
      m(header, {
        logos: {
                  dark: "assets/media/logos/rubis-logo-white.svg",
          light: "assets/media/logos/rubis-logo-white.png"
        },
        links: [{
          label: t().home_acc_info.navbar.reports,
          route: "/reports",
        }, {
          label: t().home_acc_info.navbar.user_management,
          route: "/userManagement"
        }, {
          label: t().home_acc_info.navbar.support,
          route: "/support"
        }, {
          label: t().home_acc_info.navbar.notifications,
          route: "/notifications"
        }, {
          label: t().home_acc_info.navbar.trends,
          route: "/trends-disabled"
        }]
      }),
      // <!--end::Header-->

      // <!--begin::Wrapper-->
      m("div", { "class": "app-wrapper flex-column flex-row-fluid", "id": "kt_app_wrapper" }, [
        // <!--begin::Main-->
        m("div", { "class": "app-main flex-column flex-row-fluid", "id": "kt_app_main" }, [
          // <!--begin::Content wrapper-->
          m("div", { "class": "d-flex flex-column flex-column-fluid" }, [
            // <!--begin::Toolbar-->
            m(toolbar, {
              header: {
                label: "XYZ Transporters",
                subLabel: [t().common.account_type, t().common.post_paid]
              },
              toolBarItems: [{
                label: t().home_acc_info.subheader_labels.dashboard,
                route: "/dashboard",
                routesToActivate: ["/dashboard"]
              }, {
                label: t().home_acc_info.subheader_labels.home,
                route: "/",
                routesToActivate: ["/", "/stationFinder", "/journeyPlan", "/journeyPlan/add"]
              }, {
                label: t().home_acc_info.subheader_labels.cards,
                route: "/cardList",
                routesToActivate: ["/cardList", "/departments", "/drivers"]
              }, {
                label: t().home_acc_info.subheader_labels.transactions,
                route: "/transactions",
                routesToActivate: ["/transactions"]
              }, {
                label: t().home_acc_info.subheader_labels.funds,
                route: "/funds",
                routesToActivate: ["/funds", "/cardToCard"]
              }]
            }),
            // <!--end::Toolbar-->

            // <!--begin::Content-->
            m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" }, [
              // <!--begin::Inbox App - Messages -->
              m("div", { "class": "d-flex flex-column flex-lg-row" }, [
                // <!--begin::Sidebar-->
                m(sidebar, {
                  sideBarItems: [{
                    label: t().home_acc_info.sidebar_labels.account_into,
                    icon: "bi bi-person-video",
                    route: "/"
                  },
                  {
                    label: t().home_acc_info.sidebar_labels.station_finder,
                    icon: "bi bi-pin-map-fill",
                    route: "/stationFinder"
                  },
                  {
                    label: t().home_acc_info.sidebar_labels.journey_plan,
                    icon: "bi bi-globe-americas",
                    route: "/journeyPlan",
                    routesToActivate: ["/journeyPlan", "/journeyPlan/add"]
                  }]
                }),
                // <!--end::Sidebar-->
                // <!--begin::Content-->
                m("div", { "class": "app-content container-xxl", "id": "kt_app_content" },
                  m("div", { "class": "app-container ", "id": "kt_app_content_container" },
                    [
                      m("div", { "class": "row" }, [
                        // Column 1: Bootstrap Input
                        m("div", { "class": "col-sm-12 col-md-3 col-lg-4" }, [
                          m("div", { "class": "card card-custom" }, [

                            m("div", { "class": "card-body" }, [
                              m("div", { "class": "mb-10" }, [
                                m("div", { "class": "mb-10" }, [
                                  m("div", { "class": "form-check form-check-custom form-check-solid" }, [
                                    m("input", { "class": "form-check-input", "type": "checkbox", "value": "1", "id": "automatically_pick" }),
                                    m("label", { "class": "form-check-label", "for": "automatically_pick" }, t().journey_plan.add_labels.automatically_pick)
                                  ])
                                ]),
                                m("label", { "class": "form-label" }, t().journey_plan.add_labels.start_point),
                                m("input", {
                                  "type": "text",
                                  "class": "form-control",
                                  "placeholder": t().journey_plan.add_labels.start_point,
                                }),
                                m("br"),
                                m("label", { "class": "form-label" }, t().journey_plan.add_labels.search_destination),
                                m("input", {
                                  "type": "text",
                                  "class": "form-control",
                                  "placeholder": t().journey_plan.add_labels.search_destination,
                                }),
                                m("br"),
                                m("label", { "class": "form-label" }, t().journey_plan.add_labels.estimated_distance),
                                m("input", {
                                  "type": "text",
                                  "class": "form-control",
                                  "placeholder": t().journey_plan.add_labels.estimated_distance,
                                }),
                                m("br"),
                                m("label", { "class": "form-label" }, t().journey_plan.add_labels.estimated_time),
                                m("input", {
                                  "type": "text",
                                  "class": "form-control",
                                  "placeholder": t().journey_plan.add_labels.estimated_time,
                                }),
                                m("br"),
                                m("label", { "class": "form-label" }, t().journey_plan.add_labels.num_stations),
                                m("input", {
                                  "type": "text",
                                  "class": "form-control",
                                  "placeholder": t().journey_plan.add_labels.num_stations,
                                }),
                                m('br'),
                                m("div", { "class": "d-flex justify-content-start", "data-kt-customer-table-toolbar": "base" },
                                  m("a", {
                                    "class": "text-gray-900 text-hover-primary", style: {
                                      // 'padding-bottom': '10px'
                                    }, onclick(e) {
                                      e.preventDefault();
                                      createAlert.show()
                                    }
                                  },
                                    "Create Alert"
                                  )),
                                m('br'),
                                m("div", { "class": "d-flex justify-content-start", "data-kt-customer-table-toolbar": "base" },
                                  m("button", { "class": "btn btn-primary", onclick: () => saveJourney.show() }, [
                                    // m("i", { "class": "bi bi-arrow-left" }),
                                    "Save Journey"
                                  ])
                                )
                              ])
                            ]),
                          ])



                        ]),

                        // Column 2: Google Map
                        m("div", { "class": "col-sm-12 col-md-6 col-lg-8" }, [
                          m(map, {
                            markerSelected: (meta) => console.log("marker selected", meta),
                            gpsData: []
                          })
                          // m("img", { 
                          //   src: "/assets/media/illustrations/station-journey-plan.png", 
                          //   alt: "Station Finder Map", 
                          //   class: "img-fluid", 
                          //   style: { 
                          //     width: "110%", 
                          //     borderRadius: "10px", 
                          //     boxShadow: "0 0 10px rgba(0,0,0,0.2)" 
                          //   } 
                          // })
                        ])
                      ])

                    ]
                  )
                )
                // <!--end::Content-->
              ]),
              // <!--end::Inbox App - Messages -->

            ])
            // <!--end::Content-->
          ]),
          m(footer)
        ])
      ])

    ];
  }
};
